import { Stack, TextField } from '@mui/material';
import { Typography } from '@sweep-io/sweep-design';
import { INSTRUCTIONS_SUBTITLE } from '../aiAgentsConsts';

const AgentInstructionsContent = ({
  onChange,
  value,
  placeholder,
}: {
  value: string;
  placeholder: string;
  onChange: (instructions: string) => void;
}) => {
  return (
    <Stack gap={2}>
      <Typography variant="body">
        {INSTRUCTIONS_SUBTITLE}
      </Typography>
      <TextField
        multiline
        fullWidth
        sx={{ textarea: { minHeight: '124px' } }}
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
    </Stack>
  );
};

export default AgentInstructionsContent;
